import { defineComponent, ref, SetupContext } from '@vue/composition-api';
import vueRouter from '@/router/index';
import HttpStatus from 'http-status-codes';

/**
 * 重要情報のお知らせ：登録完了
 *
 * 登録完了画面を表示する。
 */
export default defineComponent({
    setup(props, ctx: SetupContext) {
        const commonRef = ref<any>(null);
        const router = vueRouter;
        const stepper = <number>4;                           // ステッパーの4段階目

        /**
         * created
         */
        created();
        function created() {
            // titleIcon変更
            ctx.root.$store.commit('setTitleIcon', 'mdi-file-send');

            // mainTitle変更
            ctx.root.$store.commit('setMainTitle', '重要情報のお知らせ登録');

            // テーブル削除処理を呼び出す
            deleteTemporaryTable();
        }

        /**
         * 初期表示
         */
        async function deleteTemporaryTable() {
            // テーブル削除APIを呼び出す
            // URL: DELETE /api/important-information/temporary
            // パラメータ: なし
            const response = await ctx.root.$store.dispatch('importantInformation/deleteTempData');

            // APIが正常に実行できなかった場合
            if (response.status !== HttpStatus.OK) {
                // エラー画面を表示して処理を終了する
                commonRef.value.errorDisplayTransitionControl(response);
                return;
            }
        }

        /**
         * 「処理選択へ戻る」ボタンクリック処理
         */
        function navigationSelectCreation() {
            // 処理選択へ遷移
            router.push('/important-information/select-creation');
        }

        return {
            commonRef,
            stepper,
            router,
            navigationSelectCreation
        };
    }
});
